import { RoleControlledActionConfiguration } from '@/types';

export const roleConfig: RoleControlledActionConfiguration = {
  createCheckouts: {
    owner: { restricted: false, hidden: false },
    admin: { restricted: false, hidden: false },
    customer_care: { restricted: false, hidden: false },
    sales_manager: { restricted: false, hidden: false },
    sales_representative: { restricted: true, hidden: false },
    support_specialist: { restricted: true, hidden: false },
    view_only: { restricted: true, hidden: false },
  },
  updateCheckouts: {
    owner: { restricted: false, hidden: false },
    admin: { restricted: false, hidden: false },
    customer_care: { restricted: false, hidden: false },
    sales_manager: { restricted: false, hidden: false },
    sales_representative: { restricted: true, hidden: false },
    support_specialist: { restricted: true, hidden: false },
    view_only: { restricted: true, hidden: false },
  },
  deleteCheckouts: {
    owner: { restricted: false, hidden: false },
    admin: { restricted: false, hidden: false },
    customer_care: { restricted: false, hidden: false },
    sales_manager: { restricted: false, hidden: false },
    sales_representative: { restricted: true, hidden: false },
    support_specialist: { restricted: true, hidden: false },
    view_only: { restricted: true, hidden: false },
  },
};
